import { render } from "./CallLog.vue?vue&type=template&id=c65122f4&scoped=true"
import script from "./CallLog.vue?vue&type=script&lang=js"
export * from "./CallLog.vue?vue&type=script&lang=js"

import "./CallLog.vue?vue&type=style&index=0&id=c65122f4&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65122f4"]])

export default __exports__